import { unslashUri } from "./util/string"
import { removeAnyLangFromURL } from "./util/translate"

export const homeByLang = {
  es: '/',
  pt: '/pt/',
}

export const manageVoucherLoginByLang = {
  es: '/gestionar-bono/login/',
  pt: '/pt/gerir-voucher/login/',
}

export const manageVoucherFormByLang = {
  es: '/gestionar-bono/',
  pt: '/pt/gerir-voucher/',
}

export const giftCardByLang = {
  es: '/experiencias-tarjetas-regalo/',
  pt: '/pt/experiencias-cartoes-presente/',
}

export const giftCardCheckoutByLang = {
  es: '/experiencias-tarjetas-regalo/comprar/',
  pt: '/pt/experiencias-cartoes-presente/comprar/',
}

export const redeemGetAwayByLang = {
  es: '/canjear-escapada/',
  pt: '/pt/resgatar-escapadinha/',
}

export const contactByLang = {
  es: '/formulario-de-contacto/',
  pt: '/pt/formulario-de-contacto/',
}

export const legalNoticeByLang = {
  es: '/aviso-legal/',
  pt: '/pt/aviso-legal/',
}

export const privacyPolicyByLang = {
  es: '/politica-de-privacidad/',
  pt: '/pt/politica-de-privacidade/',
}

export const changeAndRefundByLang = {
  es: '/politica-cambios-y-devoluciones/',
  pt: '/pt/politica-de-devolucoes-e-trocas/',
}

export const generalConditionByLang = {
  es: '/condiciones-generales-compra/',
  pt: '/pt/condicoes-gerais-de-compra/',
}

export const cookiePolicyByLang = {
  es: '/politica-de-cookies/',
  pt: '/pt/politica-de-cookies/',
}

export const bookingConfirmationByLang = {
  es: '/confirmacion/reserva/',
  pt: '/pt/confirmacao/reserva/',
}

export const bookingCheckoutByLang = {
  es: '/service-booking/checkout/',
  pt: '/pt/service-booking/checkout/',
}

export function isHomeURL(url: string): boolean {
  const cleanURL = removeAnyLangFromURL(unslashUri(url))
  return cleanURL === ''
}

export function getStaticURLsThinContentForRobots(): Array<string> {
  return [
    ...Object.values(manageVoucherFormByLang),
    ...Object.values(giftCardCheckoutByLang),
    ...Object.values(redeemGetAwayByLang),
    ...Object.values(contactByLang),
    ...Object.values(legalNoticeByLang),
    ...Object.values(privacyPolicyByLang),
    ...Object.values(changeAndRefundByLang),
    ...Object.values(generalConditionByLang),
    ...Object.values(cookiePolicyByLang),
    ...Object.values(bookingConfirmationByLang),
    ...Object.values(bookingCheckoutByLang),
  ]
}

export function isManageVoucherLoginURL(url: string): boolean {
  for (const [_, value] of Object.entries(manageVoucherLoginByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isManageVoucherFormURL(url: string) {
  for (const [_, value] of Object.entries(manageVoucherFormByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isGiftCardURL(url: string) {
  for (const [_, value] of Object.entries(giftCardByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isGiftCardCheckoutURL(url: string) {
  for (const [_, value] of Object.entries(giftCardCheckoutByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isRedeemGetAwayURL(url: string) {
  for (const [_, value] of Object.entries(redeemGetAwayByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isContactURL(url: string) {
  for (const [_, value] of Object.entries(contactByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isLegalNoticeURL(url: string) {
  for (const [_, value] of Object.entries(legalNoticeByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isPrivacyPolicyURL(url: string) {
  for (const [_, value] of Object.entries(privacyPolicyByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isChangeAndRefundURL(url: string) {
  for (const [_, value] of Object.entries(changeAndRefundByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isGeneralConditionURL(url: string) {
  for (const [_, value] of Object.entries(generalConditionByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isCookiePolicyURL(url: string) {
  for (const [_, value] of Object.entries(cookiePolicyByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isBookingConfirmationURL(url: string) {
  for (const [_, value] of Object.entries(bookingConfirmationByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isBookingCheckoutURL(url: string) {
  for (const [_, value] of Object.entries(bookingCheckoutByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isStaticURL(url: string): boolean {
  if (isManageVoucherLoginURL(url)) {
    return true
  }

  if (isManageVoucherFormURL(url)) {
    return true
  }

  if (isGiftCardURL(url)) {
    return true
  }

  if (isGiftCardCheckoutURL(url)) {
    return true
  }

  if (isRedeemGetAwayURL(url)) {
    return true
  }

  if (isContactURL(url)) {
    return true
  }

  if (isLegalNoticeURL(url)) {
    return true
  }

  if (isPrivacyPolicyURL(url)) {
    return true
  }

  if (isChangeAndRefundURL(url)) {
    return true
  }

  if (isGeneralConditionURL(url)) {
    return true
  }

  if (isCookiePolicyURL(url)) {
    return true
  }

  if (isBookingConfirmationURL(url)) {
    return true
  }

  if (isBookingCheckoutURL(url)) {
    return true
  }

  return false
}
